var _path, _line, _line2, _line3, _line4, _circle, _circle2, _circle3, _circle4, _path2, _path3, _path4, _path5, _path6, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 303,
    viewBox: "0 0 454 303",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 167.613C-6.0574e-05 194.869 22.8556 259.961 72.2953 288.592C122.777 317.825 165.101 293.365 224.632 294.33C269.596 295.058 297.305 307.988 339.788 294.33C399.898 275.004 465.116 241.87 451.329 184.349C441.741 144.347 396.081 144.996 367.673 113.579C339.335 82.2384 342.374 49.8818 307.255 25.1166C231.235 -28.4914 138.522 11.6758 67.6478 71.0215C31.6352 101.176 6.05743e-05 140.357 0 167.613Z",
    fill: "#FAFAFC"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 157.097,
    y1: 50.9353,
    x2: 157.097,
    y2: 53.9206,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 157.097,
    y1: 59.7044,
    x2: 157.097,
    y2: 62.6896,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 151.5,
    y1: 57.0924,
    x2: 154.485,
    y2: 57.0924,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 159.336,
    y1: 57.0924,
    x2: 162.322,
    y2: 57.0924,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 361.119,
    cy: 210.925,
    r: 34.6099,
    stroke: "#CAD0E1",
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 72,
    r: 5.34698,
    stroke: "#CAD0E1",
    strokeWidth: 1.30603
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.104,
    cy: 37.1042,
    r: 3.45114,
    stroke: "#CAD0E1",
    strokeWidth: 1.30603
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.104,
    cy: 184.104,
    r: 3.45114,
    stroke: "#CAD0E1",
    strokeWidth: 1.30603
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.347 260C143.347 263.552 140.684 266.347 137.5 266.347C134.316 266.347 131.653 263.552 131.653 260C131.653 256.448 134.316 253.653 137.5 253.653C140.684 253.653 143.347 256.448 143.347 260Z",
    stroke: "#CAD0E1",
    strokeWidth: 1.30603
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M261.018 162.133C261.018 162.133 265.631 161.389 267.595 159.425C269.56 157.461 270.304 152.847 270.304 152.847C270.304 152.847 271.048 157.461 273.012 159.425C274.977 161.389 279.59 162.133 279.59 162.133C279.59 162.133 274.977 162.878 273.012 164.842C271.048 166.806 270.304 171.42 270.304 171.42C270.304 171.42 269.56 166.806 267.595 164.842C265.631 162.878 261.018 162.133 261.018 162.133Z",
    fill: "#CAD0E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.405 126.829C347.405 126.829 352.019 126.085 353.983 124.121C355.947 122.157 356.692 117.543 356.692 117.543C356.692 117.543 357.436 122.157 359.4 124.121C361.364 126.085 365.978 126.829 365.978 126.829C365.978 126.829 361.364 127.574 359.4 129.538C357.436 131.502 356.692 136.116 356.692 136.116C356.692 136.116 355.947 131.502 353.983 129.538C352.019 127.574 347.405 126.829 347.405 126.829Z",
    fill: "#CAD0E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M359 152.434C359 152.434 364.68 151.517 367.099 149.099C369.517 146.68 370.434 141 370.434 141C370.434 141 371.35 146.68 373.768 149.099C376.187 151.517 381.867 152.434 381.867 152.434C381.867 152.434 376.187 153.35 373.768 155.768C371.35 158.187 370.434 163.867 370.434 163.867C370.434 163.867 369.517 158.187 367.099 155.768C364.68 153.35 359 152.434 359 152.434Z",
    fill: "#CAD0E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M203 271.434C203 271.434 208.68 270.517 211.099 268.099C213.517 265.68 214.434 260 214.434 260C214.434 260 215.35 265.68 217.768 268.099C220.187 270.517 225.867 271.434 225.867 271.434C225.867 271.434 220.187 272.35 217.768 274.768C215.35 277.187 214.434 282.867 214.434 282.867C214.434 282.867 213.517 277.187 211.099 274.768C208.68 272.35 203 271.434 203 271.434Z",
    fill: "#CAD0E1"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 61.9404,
    y1: 106.306,
    x2: 61.9403,
    y2: 111.144,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 61.9404,
    y1: 116.239,
    x2: 61.9403,
    y2: 121.077,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 54.4904,
    y1: 113.627,
    x2: 59.3282,
    y2: 113.627,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 64.4233,
    y1: 113.627,
    x2: 69.261,
    y2: 113.627,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 52.7233,
    y1: 121.446,
    x2: 35.8081,
    y2: 138.552,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 51.4002,
    y1: 131.401,
    x2: 21.847,
    y2: 161.153,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 6.14382,
    y2: -1.30603,
    transform: "matrix(2.7095e-08 1 1 -3.13413e-08 350.111 201.129)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 6.14382,
    y2: -1.30603,
    transform: "matrix(2.7095e-08 1 1 -3.13413e-08 350.111 211.063)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 5.62079,
    y2: -1.30603,
    transform: "matrix(-1 -1.45705e-08 -1.45705e-08 1 357.037 211.063)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 5.62079,
    y2: -1.30603,
    transform: "matrix(-1 -1.56706e-08 -1.35475e-08 1 347.802 211.063)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 24.4543,
    y2: -1.30603,
    transform: "matrix(0.676828 0.736141 0.685017 -0.728527 356.743 217.255)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 41.7167,
    y2: -1.30603,
    transform: "matrix(0.678477 0.734622 0.68338 -0.730063 358.702 225.683)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer1);
export default __webpack_public_path__ + "static/media/Layer_1.0b2960f9655bbd9c0b1172e50ee2ac07.svg";
export { ForwardRef as ReactComponent };